import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-total-price',
    templateUrl: './total-price.component.html',
    styleUrls: ['./total-price.component.scss']
})
export class TotalPriceComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
